import { render, staticRenderFns } from "./oldFoot.vue?vue&type=template&id=8c88623e"
import script from "./oldFoot.vue?vue&type=script&lang=js"
export * from "./oldFoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports